import React, { Fragment } from "react";
import s from "./style.module.css";
import data from "./data";
import cn from "classnames";

const PillarsAndFoundations = ({
  state = 0,
  highlight,
  participantsCopy,
  pillarsCopy,
  participantsTitle,
  pillarsTitle,
}) => {
  const stateData = data[state];

  const participants = [
    "Government entities",
    "Civil society and individuals",
    "Academia",
    "Private sector",
    "International organizations",
  ];

  const pillars = [
    "Institutions",
    "Policies",
    "Laws and regulations",
    "Infrastructure",
    "Funding",
    "Trust",
    "Data demand",
    "Human capital",
    "Incentives",
  ];

  const all = participants.map((text, i) => {
    return {
      text: participantsCopy[i],
      pillars: pillars.map((pillar, j) => {
        return {
          id: `${text}${pillar}`,
          text: pillarsCopy[j],
          level:
            highlight === `${text}${pillar}`
              ? 4
              : stateData[`${text}${pillar}`],
        };
      }),
    };
  });

  return (
    <div className={s.wrap}>
      <strong className={s.title}>{pillarsTitle}</strong>
      <strong className={s.participantsTitle}>{participantsTitle}</strong>

      {all.map(({ text, pillars }, i) => (
        <Fragment key={i}>
          <div className={s.participant} style={{ "--column": i + 2 }}>
            <div className={s.participantText}>{text}</div>
          </div>

          {pillars.map(({ text, level }, j) => (
            <div
              key={j}
              className={cn(s.box, {
                [s[`level-${level}`]]: level,
                [s.faded]: ["2", "4", "6"].includes(state),
              })}
              style={{ "--column": i + 2, "--row": j + 3, "--i": j }}
            ></div>
          ))}
        </Fragment>
      ))}

      {pillars.map((text, i) => (
        <div key={text} className={s.pillar} style={{ "--row": i + 3 }}>
          {pillarsCopy[i]}
        </div>
      ))}
    </div>
  );
};

export default PillarsAndFoundations;
